import React from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./containers/Login";
import TaskPage from "./containers/TaskPage";
import MarkAttendance from "./containers/MarkAttendance";
import Navbar from "./containers/Navbar";
import Password from "./containers/Login/Password/index.js";
import CreatePassword from "./containers/Login/Password/CreatePassword.js";
import OtpVerify from "./containers/Login/Password/OtpVerify.js";
import ForgotPassword from "./containers/Login/Password/ForgotPassword.js";
import { MyProvider } from "./context/Context";
import AuthProvider from "./services/AuthProvider";
import Loader from "./containers/Loader/index.js";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Loader />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/password",
      element: <Password />,
    },
    {
      path: "/create-password",
      element: <CreatePassword />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "/otp-verify",
      element: <OtpVerify />,
    },
    {
      path: "/task-page",
      element: <TaskPage />,
    },
    {
      path: "/mark-attendance",
      element: <MarkAttendance />,
    },
  ]);

  return (
    <MyProvider>
      <AuthProvider>
        <Navbar  />
        <RouterProvider router={router}></RouterProvider>
      </AuthProvider>
    </MyProvider>
  );
}

export default App;
